import { Navigate, Outlet, RouteObject } from "react-router-dom";
import SelfRegistrationRoute from "./self_registration";
import ExternalRegistrationRoute from "./external_registration";
import Protected from "@/pages/protected";
import PreConfiguredRegistrationRoute from "./pre_configured_registration";
import PicklistsRoute from "./picklists";
import ExternalProviderRoute from "./external_provider";
import InstallmentScheduleRoute from "./installment_schedule";
import ProductSessionRoute from "./product_session";
import IperiaOperationsRoute from "./iperia-operations";

const RegistrationRoute: RouteObject = {
    path: "inscriptions",
    element: (
        <Protected>
            <Outlet />
        </Protected>
    ),
    children: [
        {
            index: true,
            element: <Navigate to="/inscriptions/ventes" replace />
        },
        IperiaOperationsRoute,
        {
            path: "evaluation-bi",
            async lazy() {
                const { BiPaperReviewPage } = await import("@/pages/registration/bi-paper-review");
                return { Component: BiPaperReviewPage };
            }
        },
        SelfRegistrationRoute,
        ExternalProviderRoute,
        ExternalRegistrationRoute,
        PreConfiguredRegistrationRoute,
        InstallmentScheduleRoute,
        PicklistsRoute,
        ProductSessionRoute
    ]
};

export default RegistrationRoute;
